module.exports = __webpack_public_path__ + "static/img/qrCode.6aa38475.png";